// extracted by mini-css-extract-plugin
export default {"roomContainer":"property_unit_info_roomContainer__iTdEW"};